module.exports = __webpack_public_path__ + "static/img/develop4.c28b2fa8.png";